module.exports = __webpack_public_path__ + "img/newsImg12-9.4c9d7d42.png";